import Button from "@mui/material/Button";
import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../pages/main/content/CommonTranslationKey";
import React from "react";
import {ButtonPropTypes} from "./ButtonPropTypes";

interface Props {
    onClick: (event?: any) => void,
    variant?: ButtonPropTypes.Variant,
}

export function NoButton(props: Props) {

    const {onClick, variant} = props;

    return (
        <Button
            onClick={onClick}
            variant={variant}
        >
            {_transl(CommonTranslationKey.NO)}
        </Button>
    )
}

